/**
 * The Intl helper is built to support the the new Intl
 * class within the browser.
 */
export class IntlHelper {
	/**
	 * This method will take a timestamp or unformatted time string and
	 * convert it to a human readable version.
	 *
	 * @param timestamp A timestamp or time string.
	 * @returns The formatted time string.
	 */
	public convertDateTime(timestamp: number | string, includeSeconds = false): string {
		const datetime = new Date(timestamp);

		return Intl.DateTimeFormat('en-GB', {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: includeSeconds ? 'numeric' : undefined,
			hour12: false,
			timeZone: 'Europe/London',
		}).format(datetime);
	}

	/**
	 * This method will take a number and attempt to prefix a leading zero
	 * if the number is under 10, this is to support date pickers.
	 *
	 * @param value The number value.
	 * @returns Prefixed string.
	 */
	public prefixLeadingZero(value: number | string): string {
		const val = Number.parseInt(String(value));
		if (val >= 10) {
			return String(val);
		} else {
			return `0${String(val)}`;
		}
	}
}
